<img alt="error-state" src="assets/img/success_v2.svg" />
<p>
  Deine Antworten wurden übermittelt!
  <br />
  Vielen Dank!
</p>
